/**
 * LaunchBanner — scrolling ticker strip across the top of the HUD.
 *
 * History:
 *   Apr 30 2026 iter_64 per Lead: "Grand opening should be a ticker
 *   countdown not generic state of the art. 2026 the future is now
 *   scrolling across the top not being eaten by the top like it is.
 *   Text for it: Come walk the methodology with us and watch us grow."
 *
 *   May 01 2026 per Lead: "Can you remove the demo countdown just leave
 *   coming soon no date yet." Live countdown timer + LAUNCH_DATE +
 *   ticking useEffect removed. Banner is now a calm scrolling ticker
 *   with a single steady line — no minutes counting down, no June 5
 *   2026 date. Activated when a real launch date is confirmed.
 *
 * Behaviour:
 *   • Scrolling marquee (pure CSS transform animation, 60s loop) shows
 *     the tagline + a "Full launch coming soon" suffix. No ticking
 *     countdown. No date.
 *   • Fixed height (h-9 md:h-10) so it never gets clipped by the
 *     viewport top edge — flex-shrink-0 in the HUD column keeps it
 *     deterministic.
 *   • Phase flag preserved (`data-phase` attribute) so a future change
 *     can re-introduce the countdown by flipping the phase string back
 *     to 'countdown'. Currently locked to 'pre-launch'.
 */

export default function LaunchBanner() {
  const line = (
    <span>
      <span className="text-[#D4A84A] font-hud tracking-[0.3em]">TSOGN</span>
      <span className="mx-4 text-white/40">·</span>
      <span className="text-white/95 font-hud tracking-wider">Come walk the methodology with us and watch us grow.</span>
      <span className="mx-4 text-white/40">·</span>
      <span className="text-[#2F8A92] font-hud tracking-widest">FULL LAUNCH COMING SOON</span>
    </span>
  );

  // Repeat the line 3 times inside the track so the CSS loop is seamless.
  return (
    <div
      className="pointer-events-auto flex-shrink-0 h-9 md:h-10 w-full overflow-hidden relative"
      style={{ background: '#0A0A0A', borderBottom: '1px solid rgba(212,168,74,0.12)' }}
      data-testid="launch-banner"
      data-phase="pre-launch"
    >
      <div className="launch-ticker-track flex items-center whitespace-nowrap text-sm md:text-base h-full">
        <span className="px-8" data-testid="launch-banner-countdown">{line}</span>
        <span className="px-8">{line}</span>
        <span className="px-8">{line}</span>
      </div>
    </div>
  );
}
